require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.create");

function n(n) {
  return n = n || Object.create(null), {
    on: function on(c, e) {
      (n[c] || (n[c] = [])).push(e);
    },
    off: function off(c, e) {
      n[c] && n[c].splice(n[c].indexOf(e) >>> 0, 1);
    },
    emit: function emit(c, e) {
      (n[c] || []).slice().map(function (n) {
        n(e);
      }), (n["*"] || []).slice().map(function (n) {
        n(c, e);
      });
    }
  };
}

module.exports = n;